import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Typography, makeStyles } from '@material-ui/core';
import { formattingDigitCurrency } from 'utils';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
  root: {
    //backgroundColor: 'rgba(171, 171, 171, 0.1)',
    //margin: '.3rem 0 1rem 0',
  },

  total: {
    height: '55px',

    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    '& h6': {
      fontSize: '17px',
      fontFamily: ['Nunito Sans', 'sans-serif'].join(','),
      fontWeight: 700
    },
  },
  totalDiscount: {
    height: '55px',

    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    '& h6': {
      fontSize: '18px',
      fontWeight: 700,
      fontFamily: ['Nunito Sans', 'sans-serif'].join(','),
    },
  },
  label: {
    margin: '0 1rem',
  },
  bold: {
    fontWeight: 700,
  },
}));

const Discount = ({ discount, countryCode, labelCode }) => {
  const { t } = useTranslation();
  const classes = useStyles();
  
  const { global, products } = discount || {};
  const totalDiscount = global + products;

  return (
    <Grid container>
      {global && global > 0 ? (
        <Grid item xs={12}>
          <div className={classes.total}>
            <Typography
              display="inline"
              variant="h6"
              data-testid="totalDiscount"
              className={`${classes.label} `}
            >
              {t('discount_global')}
            </Typography>
            <Typography
              display="inline"
              variant="h6"
              className={`${classes.label} $`}
              data-testid="amount"
            >
              {formattingDigitCurrency(global, countryCode, labelCode)}
            </Typography>
          </div>
        </Grid>
      ) : (
        ''
      )}
      <Grid item xs={12} className={classes.container}>
        <div className={`${classes.totalDiscount}`}>
          <Typography
            display="inline"
            variant="h6"
            data-testid="todalDiscountWithProduct"
            className={`${classes.label} ${classes.bold}`}
          >
            {t('total_discount')}
          </Typography>
          <Typography
            display="inline"
            variant="h6"
            className={`${classes.label} $`}
            data-testid="amount"
          >
            {formattingDigitCurrency(totalDiscount, countryCode, labelCode)}
          </Typography>
        </div>
      </Grid>
    </Grid>
  );
};

Discount.propTypes = {};

Discount.defaultProps = {};
export default Discount;
